import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  BarChart3,
  Building2,
  Code2,
  LogOut,
} from "lucide-react";
import { loadSession } from "../lib/auth";
import { logout } from "../lib/api";

export function MasterShell() {
  const session = loadSession();
  const navigate = useNavigate();
  const name = session?.user.name || session?.user.email || "";

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-20 border-b border-brand-800/40 bg-brand text-white">
        <div className="mx-auto flex h-14 max-w-screen-2xl items-center gap-6 px-4 sm:px-6 lg:px-8">
          <Link to="/master" className="flex items-center gap-2 font-semibold tracking-tight">
            <Logo />
            <span>AuftragsManager</span>
            <span className="rounded-full bg-white/10 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-white/80">
              Master
            </span>
          </Link>
          <nav className="flex items-center gap-1 text-sm">
            <NavItem to="/master" end icon={<Building2 className="h-4 w-4" />}>
              Unternehmen
            </NavItem>
            <NavItem to="/master/widgets" icon={<Code2 className="h-4 w-4" />}>
              Widgets
            </NavItem>
            <NavItem to="/master/stats" icon={<BarChart3 className="h-4 w-4" />}>
              Statistik
            </NavItem>
          </nav>
          <div className="ml-auto flex items-center gap-3">
            <div className="flex items-center gap-2 text-sm">
              <div className="flex h-8 w-8 items-center justify-center rounded-full bg-white/10 text-xs font-semibold">
                {initials(name)}
              </div>
              <span className="hidden text-white/80 sm:inline">{name}</span>
            </div>
            <button
              className="inline-flex items-center gap-2 rounded-lg px-3 py-1.5 text-sm text-white/70 transition hover:bg-white/10 hover:text-white"
              onClick={async () => {
                await logout();
                navigate("/login");
              }}
            >
              <LogOut className="h-4 w-4" />
              <span className="hidden sm:inline">Abmelden</span>
            </button>
          </div>
        </div>
      </header>
      <main className="page">
        <Outlet />
      </main>
    </div>
  );
}

function NavItem({
  to,
  icon,
  children,
  end,
}: {
  to: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  end?: boolean;
}) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `inline-flex items-center gap-2 rounded-lg px-3 py-1.5 transition-colors ${
          isActive
            ? "bg-white/15 font-medium text-white"
            : "text-white/70 hover:bg-white/10 hover:text-white"
        }`
      }
    >
      {icon}
      {children}
    </NavLink>
  );
}

function Logo() {
  return (
    <svg width="22" height="22" viewBox="0 0 32 32" fill="none">
      <rect width="32" height="32" rx="8" fill="white" />
      <path
        d="M9 22V10h6.5c2.5 0 4 1.4 4 3.5 0 1.7-1 2.9-2.6 3.3l3.1 5.2H17l-2.8-5h-2.7v5H9zm2.5-7h3.7c1.3 0 2.1-.6 2.1-1.7 0-1-.8-1.7-2.1-1.7h-3.7V15z"
        fill="#1a1a2e"
      />
    </svg>
  );
}

function initials(name: string): string {
  return name
    .split(/\s+/)
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
}
